import { Component, OnInit, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'app/infrastructure/services/auth.service';
import { SxSecurityService } from 'app/infrastructure/services/sxSecurity.service';
import { CacheService } from 'app/infrastructure/services/cache.service';

@Component({
  selector: 'navbar',
  templateUrl: 'navbar.component.html',
  styleUrls: ['navbar.component.scss'],
})
export class NavbarComponent {
  innerWidth: any;
  logo: string = 'assets/img/logo-soc.png';
  userDropdownId: string = 'navbarDropdownUser';
  aboutDropdownId: string = 'navbarDropdownAbout';
  mobileDropdownId: string = 'mobileDropdown';
  itsMobile: boolean = false;
  mobileIsOpen: boolean = false;
  userIsOpen: boolean = false;
  aboutIsOpen: boolean = false;
  currentUser: string;

  constructor(
    public router: Router,
    protected route: ActivatedRoute,
    public authService: AuthService,
    private cacheService: CacheService,
    public securityService: SxSecurityService
  ) {
    this.currentUser = this.cacheService.getCurrentUser();
  }

  ngAfterViewChecked(){
    this.currentUser = this.cacheService.getCurrentUser();
  }

  showIt(id: string) {
    if (id === this.mobileDropdownId) {
      this.userIsOpen = false;
      this.aboutIsOpen = false;
      this.mobileIsOpen = !this.mobileIsOpen;
    }
    if (id === this.userDropdownId) {
      this.aboutIsOpen = false;
      this.userIsOpen = !this.userIsOpen;
    }
    if (id === this.aboutDropdownId) {
      this.userIsOpen = false;
      this.aboutIsOpen = !this.aboutIsOpen;
    }
  }

  logout() {
    this.securityService.logout();
  }

  @HostListener('document:click', ['$event'])
  clickOutside(event) {
    if (event.target.id !== this.userDropdownId && this.userIsOpen)
      this.userIsOpen = false;
    if (event.target.id !== this.aboutDropdownId && this.aboutIsOpen)
      this.aboutIsOpen = false;
    if (event.target.id !== this.mobileDropdownId && this.mobileIsOpen)
      this.mobileIsOpen = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
    this.innerWidth <= 600 ? this.itsMobile = true : this.itsMobile = false;
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/navbar/navbar.component.ts